const isNotNilValue = (value) => void 1 !== value && null !== value;

// noinspection JSUnusedGlobalSymbols
export default isNotNilValue;
